module.exports = __webpack_public_path__ + "static/media/mobile834.ae97f5e3.png";